import { useNavigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';

const GREMLIN_LOGO = 'https://customer-assets.emergentagent.com/job_8a97e9c9-a75b-4894-af5b-5ab6ea8e8ae3/artifacts/d97xwjyk_Logo.png';
const CONTRACT_ADDRESS = "GFG...coming soon";

const HomeFooter = () => {
  const navigate = useNavigate();

  const copyContract = () => {
    navigator.clipboard.writeText(CONTRACT_ADDRESS);
  };

  return (
    <footer className="border-t border-purple-500/20 bg-gradient-to-t from-purple-900/10 to-transparent">
      {/* Mobile Footer — minimal */}
      <div className="md:hidden py-6 px-5">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate('/')}>
            <img src={GREMLIN_LOGO} alt="GFG" className="w-8 h-8 object-contain" />
            <span className="font-bold text-sm text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400">$GFG</span>
          </div>
          <div className="flex gap-2">
            <a href="https://x.com/GFG_Token" target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-white/5 border border-white/10 rounded-lg flex items-center justify-center">
              <svg className="w-3.5 h-3.5 text-gray-400" fill="currentColor" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
            </a>
            <a href="https://discord.gg/3wH7NaVXxP" target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-white/5 border border-white/10 rounded-lg flex items-center justify-center">
              <svg className="w-3.5 h-3.5 text-gray-400" fill="currentColor" viewBox="0 0 24 24"><path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/></svg>
            </a>
          </div>
        </div>
        <p className="text-gray-600 text-[10px] text-center">
          &copy; 2025 Gas Free Gremlins &middot; $GFG is a meme token. Not financial advice.
        </p>
      </div>

      {/* Desktop Footer — full */}
      <div className="hidden md:block py-12 px-6">
        <div className="max-w-6xl mx-auto">
        {/* Main Footer Grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-10">
          
          {/* Brand Column */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4 cursor-pointer group" onClick={() => navigate('/')}>
              <img 
                src={GREMLIN_LOGO}
                alt="Gas Free Gremlins"
                className="w-12 h-12 object-contain drop-shadow-[0_0_10px_rgba(168,85,247,0.5)] group-hover:scale-110 transition-transform"
              />
              <div className="flex flex-col">
                <span className="font-bold text-lg text-transparent bg-clip-text bg-gradient-to-r from-purple-400 via-pink-400 to-purple-400">
                  Gas Free Gremlins
                </span>
                <span className="text-xs text-green-400 font-semibold">$GFG</span>
              </div>
            </div>
            <p className="text-gray-500 text-sm mb-4">
              The gremlins ate the gas fees. Join the chaos on Solana.
            </p>
            {/* Buy Button - Shiny Neon Style */}
            <div 
              className="group relative inline-flex items-center gap-2 px-6 py-3 rounded-full font-bold text-sm overflow-hidden cursor-default"
              style={{
                background: 'linear-gradient(135deg, rgba(168,85,247,0.15), rgba(168,85,247,0.08))',
                border: '1px solid rgba(168,85,247,0.25)',
              }}
            >
              <span className="relative z-10 text-purple-400/70">$GFG Coming Soon</span>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><button onClick={() => navigate('/')} className="text-gray-400 hover:text-purple-400 transition-colors text-sm">Home</button></li>
              <li><button onClick={() => navigate('/arcade')} className="text-gray-400 hover:text-purple-400 transition-colors text-sm">Arcade</button></li>
              <li><button onClick={() => navigate('/airdrop')} className="text-gray-400 hover:text-purple-400 transition-colors text-sm">Airdrop</button></li>
              <li><button onClick={() => navigate('/fair-launch')} className="text-gray-400 hover:text-purple-400 transition-colors text-sm">Fair Launch</button></li>
              <li><button onClick={() => navigate('/stats')} className="text-gray-400 hover:text-purple-400 transition-colors text-sm">Stats</button></li>
              <li><button onClick={() => navigate('/chancellor')} className="text-gray-400 hover:text-amber-400 transition-colors text-sm">The Chancellor <span className="text-[9px] tracking-widest text-amber-500/70 ml-1">NEW</span></button></li>
            </ul>
          </div>
          
          {/* Resources */}
          <div>
            <h4 className="text-white font-semibold mb-4">Resources</h4>
            <ul className="space-y-2">
              <li><button onClick={() => navigate('/docs')} className="text-gray-400 hover:text-purple-400 transition-colors text-sm">Documentation</button></li>
              <li><a href="/docs/whitepaper.pdf" target="_blank" className="text-gray-400 hover:text-purple-400 transition-colors text-sm">Whitepaper</a></li>
              <li><a href="/docs/roadmap.pdf" target="_blank" className="text-gray-400 hover:text-purple-400 transition-colors text-sm">Roadmap</a></li>
              <li><a href="/docs/faq.pdf" target="_blank" className="text-gray-400 hover:text-purple-400 transition-colors text-sm">FAQ</a></li>
            </ul>
          </div>
          
          {/* Community & Legal */}
          <div>
            <h4 className="text-white font-semibold mb-4">Community</h4>
            <div className="flex gap-3 mb-6">
              <a href="https://x.com/GFG_Token" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-white/5 hover:bg-purple-500/20 border border-white/10 rounded-lg flex items-center justify-center transition-colors group">
                <svg className="w-4 h-4 text-gray-400 group-hover:text-purple-400" fill="currentColor" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>
              <a href="https://discord.gg/3wH7NaVXxP" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-white/5 hover:bg-purple-500/20 border border-white/10 rounded-lg flex items-center justify-center transition-colors group">
                <svg className="w-4 h-4 text-gray-400 group-hover:text-purple-400" fill="currentColor" viewBox="0 0 24 24"><path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/></svg>
              </a>
            </div>
            <h4 className="text-white font-semibold mb-3 text-sm">Legal</h4>
            <ul className="space-y-1">
              <li><a href="/docs/terms-of-service.pdf" target="_blank" className="text-gray-500 hover:text-gray-400 transition-colors text-xs">Terms of Service</a></li>
              <li><a href="/docs/privacy-policy.pdf" target="_blank" className="text-gray-500 hover:text-gray-400 transition-colors text-xs">Privacy Policy</a></li>
              <li><a href="/docs/risk-disclosure.pdf" target="_blank" className="text-gray-500 hover:text-gray-400 transition-colors text-xs">Risk Disclosure</a></li>
            </ul>
          </div>
        </div>
        
        {/* Contract Address Bar */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 py-4 px-5 bg-white/[0.02] border border-white/5 rounded-xl mb-6">
          <div className="flex items-center gap-3">
            <span className="text-gray-500 text-sm">Contract:</span>
            <code className="text-purple-400 text-sm font-mono">{CONTRACT_ADDRESS}</code>
            <button 
              onClick={copyContract}
              className="text-gray-500 hover:text-purple-400 transition-colors"
              title="Copy contract address"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
            </button>
          </div>
          <div className="flex items-center gap-4">
            <a href="https://solscan.io" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-purple-400 text-xs transition-colors">View on Solscan</a>
            <span className="text-gray-600 text-xs">Token Launch Coming Soon</span>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-6 border-t border-white/5">
          <p className="text-gray-600 text-xs">
            &copy; 2025 Gas Free Gremlins. All rights reserved. Built with chaos on Solana.
          </p>
          <p className="text-gray-700 text-xs flex items-center gap-1">
            <AlertTriangle className="w-3 h-3 text-yellow-500/70" />
            $GFG is a meme token. Not financial advice. DYOR.
          </p>
        </div>
        </div>
      </div>
    </footer>
  );
};

export default HomeFooter;
